/*
 * Opens the partner's own site, where the member converts their points. The legacy
 * /v1/exchangePoints call that used to record this first was retired with Linkpass.
 */
const convertPartnerPoints = (partnerUrl) => () => {
  window.open(partnerUrl);
};

export default convertPartnerPoints;
